<template>
  <div class="cleed-icons" :class="dark ? 'dark' : ''">
    <div v-if="icon === 'context-all'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style="vertical-align: -0.125em"
        :width="width"
        :height="height"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 16 16"
      >
        <g fill="currentColor">
          <path
            d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
          />
          <path
            d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0z"
          />
        </g>
      </svg>
    </div>
    <div v-if="icon === 'context-chat'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style="vertical-align: -0.125em"
        :width="width"
        :height="height"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          d="M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3M17,12V10H15V12H17M13,12V10H11V12H13M9,12V10H7V12H9Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-info-orders'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-style-profile'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style="vertical-align: -0.125em"
        :width="width"
        :height="height"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 100 100"
      >
        <path
          fill="currentColor"
          d="M2.063 51.733a4.127 4.127 0 0 0-1.51 5.637l18.34 31.768a4.127 4.127 0 0 0 5.638 1.51l73.406-42.38a4.127 4.127 0 0 0 1.51-5.638l-18.34-31.768a4.127 4.127 0 0 0-5.638-1.51Zm7.701 5.084l66.258-38.254l14.214 24.62l-4.775 2.757l-5.327-9.229l-3.574 2.064l5.327 9.228l-5.465 3.156l-5.328-9.229l-3.574 2.064l5.328 9.228l-5.459 3.152l-5.328-9.229l-3.574 2.064l5.328 9.228l-5.465 3.156l-7.404-12.823l-3.574 2.063l7.404 12.823l-5.466 3.156l-5.328-9.229l-3.574 2.064l5.328 9.228l-5.459 3.151l-5.327-9.228l-3.574 2.064l5.327 9.228l-5.465 3.155l-5.328-9.228l-3.574 2.064l5.328 9.228l-3.686 2.128z"
          color="currentColor"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-whatsApp'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M12.04,2C6.58,2 2.13,6.45 2.13,11.91C2.13,13.66 2.59,15.36 3.45,16.86L2.05,22L7.3,20.62C8.75,21.41 10.38,21.83 12.04,21.83C17.5,21.83 21.95,17.38 21.95,11.92C21.95,9.27 20.92,6.78 19.05,4.91C17.18,3.03 14.69,2 12.04,2M12.05,3.67C14.25,3.67 16.31,4.53 17.87,6.09C19.42,7.65 20.28,9.72 20.28,11.92C20.28,16.46 16.58,20.15 12.04,20.15C10.56,20.15 9.11,19.76 7.85,19L7.55,18.83L4.43,19.65L5.26,16.61L5.06,16.29C4.24,15 3.8,13.47 3.8,11.91C3.81,7.37 7.5,3.67 12.05,3.67M8.53,7.33C8.37,7.33 8.1,7.39 7.87,7.64C7.65,7.89 7,8.5 7,9.71C7,10.93 7.89,12.1 8,12.27C8.14,12.44 9.76,14.94 12.25,16C12.84,16.27 13.3,16.42 13.66,16.53C14.25,16.72 14.79,16.69 15.22,16.63C15.7,16.56 16.68,16.03 16.89,15.45C17.1,14.87 17.1,14.38 17.04,14.27C16.97,14.17 16.81,14.11 16.56,14C16.31,13.86 15.09,13.26 14.87,13.18C14.64,13.1 14.5,13.06 14.31,13.3C14.15,13.55 13.67,14.11 13.53,14.27C13.38,14.44 13.24,14.46 13,14.34C12.74,14.21 11.94,13.95 11,13.11C10.26,12.45 9.77,11.64 9.62,11.39C9.5,11.15 9.61,11 9.73,10.89C9.84,10.78 10,10.6 10.1,10.45C10.23,10.31 10.27,10.2 10.35,10.04C10.43,9.87 10.39,9.73 10.33,9.61C10.27,9.5 9.77,8.26 9.56,7.77C9.36,7.29 9.16,7.35 9,7.34C8.86,7.34 8.7,7.33 8.53,7.33Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-your-mode'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M16.23,18L12,15.45L7.77,18L8.89,13.19L5.16,9.96L10.08,9.54L12,5L13.92,9.53L18.84,9.95L15.11,13.18L16.23,18M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-rewards'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M22.5,10H15.75C15.13,10 14.6,10.38 14.37,10.91L12.11,16.2C12.04,16.37 12,16.56 12,16.75V18C12,18.55 12.45,19 13,19H18.18L17.5,22.18V22.42C17.5,22.73 17.63,23 17.83,23.22L18.62,24L23.56,19.06C23.83,18.79 24,18.41 24,18V11.5C24,10.67 23.33,10 22.5,10M12,6C12,5.45 11.55,5 11,5H5.82L6.5,1.82V1.59C6.5,1.28 6.37,1 6.17,0.79L5.38,0L0.44,4.94C0.17,5.21 0,5.59 0,6V12.5C0,13.33 0.67,14 1.5,14H8.25C8.87,14 9.4,13.62 9.63,13.09L11.89,7.8C11.96,7.63 12,7.44 12,7.25V6Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-live-shop'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M5.5,16.8C4.8,16.8 4.3,16.2 4.3,15.6C4.3,14.9 4.9,14.4 5.5,14.4C6.8,16.2 6.2,16.8 5.5,16.8M5.5,12C3.6,12 2,13.6 2,15.5C2,18.1 5.5,22 5.5,22C9,13.6 7.4,12 5.5,12M4,6C3.4,6 3,6.4 3,7V10.6C3.6,10.3 4.3,10.1 5,10V8H15V16H11C10.9,16.7 10.8,17.4 10.5,18H16C16.6,18 17,17.6 17,17V13.5L21,17.5V6.5L17,10.5V7C17,6.4 16.6,6 16,6H4Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-product-s'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.2 19.31,8.89L22.41,12L21,13.39L17.89,10.31C17.2,10.75 16.38,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4C14.12,4 13,5.12 13,6.5C13,7.88 14.12,9 15.5,9C16.88,9 18,7.88 18,6.5C18,5.12 16.88,4 15.5,4M4,4H9.5C9.19,4.79 9,5.64 9,6.5C9,10.09 11.91,13 15.5,13C16.18,13 16.83,12.89 17.46,12.69L20,15.23V16C20,17.1 19.1,18 18,18H13.9L10.2,21.71C10,21.89 9.76,22 9.5,22H9C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V6C2,4.9 2.9,4 4,4Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-filtered-s'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.2 19.31,8.89L22.41,12L21,13.39L17.89,10.31C17.2,10.75 16.38,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4C14.12,4 13,5.12 13,6.5C13,7.88 14.12,9 15.5,9C16.88,9 18,7.88 18,6.5C18,5.12 16.88,4 15.5,4M4,4H9.5C9.19,4.79 9,5.64 9,6.5C9,10.09 11.91,13 15.5,13C16.18,13 16.83,12.89 17.46,12.69L20,15.23V16C20,17.1 19.1,18 18,18H13.9L10.2,21.71C10,21.89 9.76,22 9.5,22H9C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V6C2,4.9 2.9,4 4,4Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-visual-s'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M18,16H17.42L16.61,15.19C17.5,14 18,12.5 18,11C18,7.13 14.87,4 11,4C9.5,4 8,4.5 6.79,5.4C3.7,7.72 3.07,12.11 5.39,15.2C7.71,18.29 12.1,18.92 15.19,16.6L16,17.41V18L21,23L23,21L18,16M11,16C8.24,16 6,13.76 6,11M3,6L1,8V1H8L6,3H3V6M21,1V8L19,6V3H16L14,1H21M6,19L8,21H1V14L3,16V19H6Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-3d-mode'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M7.47,21.5C4.2,19.94 1.86,16.76 1.5,13H0C0.5,19.16 5.66,24 11.95,24L12.61,23.97L8.8,20.16L7.47,21.5M8.36,14.96C8.17,14.96 8,14.93 7.84,14.88C7.68,14.82 7.55,14.75 7.44,14.64C7.33,14.54 7.24,14.42 7.18,14.27C7.12,14.13 7.09,13.97 7.09,13.8H5.79C5.79,14.16 5.86,14.5 6,14.75C6.14,15 6.33,15.25 6.56,15.44C6.8,15.62 7.07,15.76 7.38,15.85C7.68,15.95 8,16 8.34,16C8.71,16 9.06,15.95 9.37,15.85C9.69,15.75 9.97,15.6 10.2,15.41C10.43,15.22 10.62,15 10.75,14.69C10.88,14.4 10.95,14.08 10.95,13.72C10.95,13.53 10.93,13.34 10.88,13.16C10.83,13 10.76,12.81 10.65,12.65C10.55,12.5 10.41,12.35 10.25,12.22C10.08,12.09 9.88,12 9.64,11.91C9.84,11.82 10,11.71 10.16,11.58C10.31,11.45 10.43,11.31 10.53,11.16C10.63,11 10.7,10.86 10.75,10.7C10.8,10.54 10.82,10.38 10.82,10.22C10.82,9.86 10.76,9.54 10.64,9.26C10.5,9 10.35,8.75 10.13,8.57C9.93,8.38 9.66,8.24 9.36,8.14C9.05,8.05 8.71,8 8.34,8C8,8 7.65,8.05 7.34,8.16C7.04,8.27 6.77,8.42 6.55,8.61C6.34,8.8 6.17,9 6.04,9.28C5.92,9.54 5.86,9.82 5.86,10.13H7.16C7.16,9.96 7.19,9.81 7.25,9.68C7.31,9.55 7.39,9.43 7.5,9.34C7.61,9.25 7.73,9.17 7.88,9.12C8.03,9.07 8.18,9.04 8.36,9.04C8.76,9.04 9.06,9.14 9.25,9.35C9.44,9.55 9.54,9.84 9.54,10.21C9.54,10.39 9.5,10.55 9.46,10.7C9.41,10.85 9.32,10.97 9.21,11.07C9.1,11.17 8.96,11.25 8.8,11.31C8.64,11.37 8.44,11.4 8.22,11.4H7.45V12.43H8.22C8.44,12.43 8.64,12.45 8.82,12.5C9,12.55 9.15,12.63 9.27,12.73C9.39,12.84 9.5,12.97 9.56,13.13C9.63,13.29 9.66,13.5 9.66,13.7C9.66,14.11 9.54,14.42 9.31,14.63C9.08,14.86 8.76,14.96 8.36,14.96M16.91,9.04C16.59,8.71 16.21,8.45 15.77,8.27C15.34,8.09 14.85,8 14.31,8H11.95V16H14.25C14.8,16 15.31,15.91 15.76,15.73C16.21,15.55 16.6,15.3 16.92,14.97C17.24,14.64 17.5,14.24 17.66,13.78C17.83,13.31 17.92,12.79 17.92,12.21V11.81C17.92,11.23 17.83,10.71 17.66,10.24C17.5,9.77 17.23,9.37 16.91,9.04M16.5,12.2C16.5,12.62 16.47,13 16.38,13.33C16.28,13.66 16.14,13.95 15.95,14.18C15.76,14.41 15.5,14.59 15.24,14.71C14.95,14.83 14.62,14.89 14.25,14.89H13.34V9.12H14.31C15.03,9.12 15.58,9.35 15.95,9.81C16.33,10.27 16.5,10.93 16.5,11.8M11.95,0L11.29,0.03L15.1,3.84L16.43,2.5C19.7,4.06 22.04,7.23 22.39,11H23.89C23.39,4.84 18.24,0 11.95,0Z"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-size'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M9,1V2H10V5H9V6H12V5H11V2H12V1M9,7C7.89,7 7,7.89 7,9V21C7,22.11 7.89,23 9,23H21C22.11,23 23,22.11 23,21V9C23,7.89 22.11,7 21,7M1,9V12H2V11H5V12H6V9H5V10H2V9M9,9H21V21H9M14,10V11H15V16H11V15H10V18H11V17H15V19H14V20H17V19H16V17H19V18H20V15H19V16H16V11H17V10"
        />
      </svg>
    </div>
    <div v-if="icon === 'context-virtual-t-on'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
      >
        <path
          d="M12,4C10.07,4 8.5,5.57 8.5,7.5H10.5C10.5,6.67 11.17,6 12,6C12.83,6 13.5,6.67 13.5,7.5C13.5,8.33 12.83,9 12,9C11.45,9 11,9.45 11,10V11.75L2.4,18.2C2.4,18.75 2.45,20 3,20H21C21.55,20 21.6,18.75 21.6,18.2L13,11.75V10.85C14.93,10.85 15.5,9.43 15.5,7.5C15.5,5.57 13.93,4 12,4M12,13.5L18,18H6Z"
        />
      </svg>
    </div>

    <div v-if="icon === 'messenger-notification'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2zM9.5 21h5a2.5 2.5 0 1 1-5 0z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "CleedIcons",
  props: {
    icon: {
      type: String,
      default: "",
    },
    width: {
      String,
      default: "24",
    },
    height: {
      String,
      default: "24",
    },
    dark: {
      Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.cleed-icons {
  fill: white;
  &.dark {
    fill: black;
  }
}
</style>
